<kehe-phoenix-error-panel [config]="permissionsConfig">
  <ng-container body>
    <p>
      The requested page requires authorization for access. If you need help,
      please contact support at
      <a href="mailto:suppliersupport@kehe.com">suppliersupport&#64;kehe.com</a>.
    </p>
    <kehe-phoenix-button (click)="goToHome()" classAttr="btn-medium btn-primary"
      >Home</kehe-phoenix-button
    >
  </ng-container>
</kehe-phoenix-error-panel>
